import React from 'react';
import clsx from 'clsx';
import styles from './RoundedProgressBar.scss';
export function RoundedProgressBar(_ref) {
  let {
    progress,
    height = '8px',
    backgroundColor = '#e0e0e0',
    fillColor = '#007bff',
    className,
    'aria-label': ariaLabel = 'Loading progress'
  } = _ref;
  const clampedProgress = Math.min(100, Math.max(0, progress));
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, className),
    style: {
      height,
      backgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    role: "progressbar",
    "aria-valuenow": clampedProgress,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-label": ariaLabel,
    className: styles.filler,
    style: {
      width: `${clampedProgress}%`,
      backgroundColor: fillColor
    }
  }));
}
//# sourceMappingURL=RoundedProgressBar.js.map